import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendMicrosoftPush } from 'services/pod';
import { ISendPushNotificationPayload } from 'services/pod/types';

export const ThunkSendMicrosoftPush = createAsyncThunk(
  'pod/sendMicrosoftPush',
  async (payload: ISendPushNotificationPayload) => sendMicrosoftPush(payload).then(res => res.data),
);
